import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// --- Pages Routing ---
import { PagesRoutingModule } from './pages-routing.module';

// --- Page ---
import { PagesComponent } from './pages.component';

// --- PrimeNG ---
import { ScrollTopModule } from 'primeng/scrolltop';
import { ToastModule } from 'primeng/toast';

// --- Components ---
import { DialogsModule } from '@components/dialogs/dialogs.module';
import { FooterModule } from '@components/footer/footer.module';
import { HeaderModule } from '@components/header/header.module';
import { WhatsAppButtonModule } from '@components/whatsapp-button/whatsapp-button.module';

@NgModule({
	declarations: [PagesComponent],
	imports: [
		CommonModule,

		// --- Pages Routing ---
		PagesRoutingModule,

		// --- PrimeNG ---
		ScrollTopModule,
		ToastModule,

		// --- Components ---
		DialogsModule,
		FooterModule,
		HeaderModule,
		WhatsAppButtonModule,
	],
})
export class PagesModule {}
